import { render } from "./RegisterOrUploadTemplate.vue?vue&type=template&id=38657924&scoped=true"
import script from "./RegisterOrUploadTemplate.vue?vue&type=script&lang=js"
export * from "./RegisterOrUploadTemplate.vue?vue&type=script&lang=js"

import "./RegisterOrUploadTemplate.vue?vue&type=style&index=0&id=38657924&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38657924"]])

export default __exports__